import { buildModelManager } from "../builder.js";
const DefaultPhiVaultObjectSelection = {
  __typename: true,
  id: true,
  bucketName: true,
  byteSize: true,
  createdAt: true,
  createdById: true,
  displayFileName: true,
  institution: true,
  kmsKeyName: true,
  metadata: true,
  mimeType: true,
  objectName: true,
  originalFileNameHash: true,
  provider: true,
  qaChartId: true,
  quickChartEvaluationId: true,
  retentionExpiresAt: true,
  sha256: true,
  sourceReference: true,
  sourceSystem: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "phiVaultObject";
const pluralModelApiIdentifier = "phiVaultObjects";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiVaultObjectSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "phiVaultObjectGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PhiVaultObjectManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPhiVaultObjectSelection,
  operations
);
export {
  DefaultPhiVaultObjectSelection,
  PhiVaultObjectManager
};
//# sourceMappingURL=PhiVaultObject.js.map
